import { render, staticRenderFns } from "./PapasMergeClosedCard.vue?vue&type=template&id=2d9f74ea&scoped=true&"
import script from "./PapasMergeClosedCard.vue?vue&type=script&lang=js&"
export * from "./PapasMergeClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./PapasMergeClosedCard.vue?vue&type=style&index=0&id=2d9f74ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f74ea",
  null
  
)

export default component.exports